export default "__VITE_ASSET__c3796812__"